import StaticPageLayout from "../components/StaticPageLayout";
import { COMPANY_PAGES } from "../data/companyPagesContent";

const PressKitPage = () => (
  <StaticPageLayout page={COMPANY_PAGES["press-kit"]} testId="press-kit-page" />
);

export default PressKitPage;
